module.exports = __webpack_public_path__ + "img/culture_02.d2b07860.png";